export default "__VITE_ASSET__DPEds$vg__"